/**
 * EntityDefaultVarietyName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import VarietyName from '../VarietyName';

// Selectors
import { makeSelectEntityValue } from '../../services/entities/selectors';

interface Props {
    defaultVarietyId?: number;
    defaultName?: ?string;
    prefix?: string;
}

export class EntityDefaultVarietyName extends React.PureComponent<Props> {
    render() {
        const { defaultVarietyId, defaultName, prefix } = this.props;
        return (
            <VarietyName
                varietyId={defaultVarietyId}
                defaultName={defaultName}
                prefix={prefix}
                showGeneric={!!defaultVarietyId}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    defaultVarietyId: makeSelectEntityValue('defaultVarietyId')
});

export default connect(mapStateToProps)(EntityDefaultVarietyName);
